module.exports = __webpack_public_path__ + "202408221624/img/btn_banner_new.b6daaf2c.png";